module.exports = __webpack_public_path__ + "img/wallex.dfd8d1ec.png";